import React from 'react';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import {createRoot} from "react-dom/client"
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './pages/app/App';
import Home from './pages/home/Home';
import ViewProject from './pages/viewProject/ViewProject';
import UserProfile from './pages/userProfile/UserProfile';
import CreateProject from './pages/createProject/CreateProject';
import Nav from './globalComponents/nav/Nav'
import MyProjects from './pages/myProjects/MyProjects';
import UpdateProject from './pages/updateProject/UpdateProject';
import Notification from './pages/notification/Notification';
import ViewAllProjects from './pages/viewAllProjects/ViewAllProjects';

import { BrowserRouter as Router, Routes, Route, Link, BrowserRouter } from "react-router-dom";

import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import ViewAllUsers from './pages/viewAllUsers/ViewAllUsers';


const container = (document.getElementById('root'));
const root = createRoot(container);
root.render(
  
    <BrowserRouter>
    
      <Routes>
        <Route path="home" element={<App />} />
        <Route path="/" index element={<Home />} />
        <Route path="viewProject/:projectId" element={<ViewProject />} />
        <Route path="userProfile/:userId" element={<UserProfile />} />
        <Route path="createProject" element={<CreateProject />} />
        
        <Route path="notification" element={<Notification />} />
        <Route path="viewAllUsers" element={<ViewAllUsers />} />
        <Route path="viewAllProjects" element={<ViewAllProjects />} />
        <Route path="myProjects" element={<MyProjects />} />
        <Route path="updateProject/:projectId" element={<UpdateProject />} />
      </Routes>
      
    </BrowserRouter>
    
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals